import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const rocksdbRWRaftEngineSchema: Schema = {
  title: 'Raft Engine',
  level: 3,
  columns: commonColumns
}
